<template>
  <div>
    <nav-bar-component />
  </div>
  <div class="col-sm-6 col-md-12 mx-auto">
    <div class="row mx-auto">
      <div class="col-sm-12 col-md-5">
        <div class="container-geral">
          <div class="container-center h3">
            <span v-if="hasCustomer">{{ name }}, falta pouco para você começar a utilizar o <span
                class="start-plan-text"><strong>RD STATION CONVERSAS</strong></span></span>
            <span v-else>Não encontramos o link de pagamento da sua proposta</span>
          </div>
          <div class="container-center h5 mt-3">
            <span class="text-secondary" v-if="hasCustomer">Para efetuar o pagamento da sua proposta, clique no botão
              abaixo.</span>
            <span class="text-secondary" v-else> Estamos processando seus dados para gerar o seu pagamento. Você pode
              tentar novamente em breve, ou entrar em contato com nossos canais de atendimento.</span>
          </div>
          <div v-on:click="StartBilling()" class="container-center mt-4" v-if="hasCustomer">
            <button class="btn button-next start-button" :disabled="isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm button-text" role="status"
                aria-hidden="true"></span>
              <strong>Prosseguir para pagamento</strong></button>
          </div>
          <div v-on:click="refreshPage()" class="container-center mt-4" v-else>
            <button class="btn button-next start-button fw-bold">
              <span class="button-text" role="status" aria-hidden="true"></span>
              Tentar novamente</button>
          </div>
        </div>
      </div>
      <div class="col-md-6 imagem">
        <img src="https://tallos-chat.s3.us-east-2.amazonaws.com/novo-layout/PICTURE-EXPORTE_HERE.svg" alt="FotoTallos"
          class="photoSize" v-if="hasCustomer">
        <img src="../assets/error-rd.svg" alt="FotoTallos" class="photoSize" v-else>
      </div>
    </div>
    <div>

    </div>
    <div class="row">
      <div class="col">
        <footer-tallos-informations />
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { billingApiUrl } from "@/config/runtime-config";

export default {
  name: "App",
  data() {
    return {
      params: {},
      name: "",
      isLoading: false,
      config: {},
      request: "",
      hasCustomer: true,
      oneTimeCredit: 0
    };
  },

  mounted() {
    const params = this.$route.params;
    this.params = params;

    this.getCustomerById();
  },
  created() {
    this.updateTitle();
  },

  watch: {
    $route() {
      this.updateTitle();
    },
  },
  methods: {
    refreshPage() {
      location.reload();
    },

    updateTitle() {
      const pageTitle = this.$route.meta.title || "Título padrão";
      document.title = pageTitle;
    },

    StartBilling() {
      this.isLoading = true;
      const date = new Date();
      let data = JSON.stringify({
        id_customer: this.params.customer,
        code: this.params.code,
        start_additional_subscriptions: true,
        subscription: {
          payment_expiration_day: Number(date.getDate()),
        },
        customer: {
          country: "BR",
        },
        one_time_credit: this.oneTimeCredit
      });

      this.request = this.httpConfig(
        "post",
        "subscription/start-billing",
        data
      );

      axios(this.request)
        .then(() => {
          this.$router.push({
            name: "FinancialPanel",
            params: {
              code: this.params.code,
              customer: this.params.customer,
            },
          });
        })
        .catch(function (error) {
          console.error(error);
        });
      setTimeout(() => {
        this.isLoading = false;
      }, 15000);
    },

    async getCustomerById() {
      this.config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}customer/${this.params.customer}/company/${this.companyId}`,
        headers: {},
      };

      await axios
        .request(this.config)
        .then((response) => {
          this.name = response.data.data.customer.name;
        })
        .catch(() => {
          this.hasCustomer = false
        });

      // Buscar proposta para obter o crédito avulso
      try {
        const proposalResponse = await axios.get(
          `${billingApiUrl()}proposal/${this.companyId}`
        );
        if (proposalResponse.data && proposalResponse.data.one_time_credit) {
          this.oneTimeCredit = proposalResponse.data.one_time_credit;
        }
      } catch (error) {
        console.error('Erro ao buscar proposta:', error);
      }
    },

    httpConfig(method, route, data) {
      var config = {
        method: method,
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}${route} `,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      return config;
    },
  },
  computed: {
    companyId() {
      return this.params.code?.split(":").at(-1);
    },
  }
};
</script>

<style scoped>
.container-geral {
  margin-top: 250px;
  margin-left: 150px;
  font-size: 'Nunito Sans', sans-serif;
}

.container-center {
  display: flex;
  justify-content: center;
  text-align: left;
  width: 90%;
}

.btn.btn.button-next.start-button {
  background-color: #19C1CE;
  border-radius: 2px;
  color: #212429;
  font-weight: 400;
  height: auto;
}

.btn.button-next.start-button:hover {
  background-color: #3BE5EB;
  color: #212429;
  height: auto;
}

.button {
  display: flex;
  justify-content: center !important;
  margin-top: 50px;
}

.button-next {
  width: auto;
  height: 50px;
  border-radius: 2px !important;
  margin: 5px;
}

.photoSize {
  width: 100%;
  height: auto;
  border-radius: 40px;
  margin-top: 15%;
  margin-right: 20%;
}

.start-plan-text {
  color: #11A7B6;
  font-size: 28px;
}

@media screen and (max-width: 1200px) {
  .container-geral {
    margin-top: 200px;
    margin-left: 10px;
  }

  .container-center {
    display: flex !important;
    justify-content: center !important;
    text-align: center !important;
    width: 90%;
  }


}
</style>
